import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { Environment, UserDateFormats } from '@iot-platform/models/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private http: HttpClient = inject(HttpClient);
  private renderer2: Renderer2;
  private rendererFactory: RendererFactory2 = inject(RendererFactory2);
  private document: Document = inject(DOCUMENT);
  private environment: Environment = inject(ENVIRONMENT);

  constructor() {
    this.renderer2 = this.rendererFactory.createRenderer(null, null);
  }

  public loadProfile(): Observable<any> {
    return this.http.get(`${this.environment.api.url}/account`);
  }

  public saveUserProfile(user): Observable<any> {
    return this.http.patch(`${this.environment.api.url}/account`, user);
  }

  public setThemeOverlay(): void {
    this.renderer2.addClass(this.document.body, 'default-theme');
  }

  public getAppDateFormats(): Observable<UserDateFormats[]> {
    return this.http.get<UserDateFormats[]>('assets/data/app-date-formats.json');
  }
}
